const { h, render, Component } = require('preact');
const OrderLevelSSA = require('./order_level_ssa')
const VoucherLevelSSA = require('./voucher_level_ssa')
const DefaultSSA = require('./default_ssa')
const Web2018Helper = require('../../../helper')

const ORDER_LEVEL_SSAs = ['edit_order', 'cancel_order', 'track_order', 'update_shipping', 'cancel_reservations', 'refund_request']
const VOUCHER_LEVEL_SSAs = ['trade_in', 'view_voucher', 'print_gift_card_voucher', 'return_item']
const VOUCHER_LEVEL_SSA_LANDING = ['trade_in', 'return_item']

class SSAButtons extends Component {
  constructor(props) {
    super(props);
  }

  getOrderLevelSSAs(){
    if (lodash.has(this.props.orderDetails, 'metadata.serviceActions')){
      return lodash.intersection(ORDER_LEVEL_SSAs, this.props.orderDetails.metadata.serviceActions);
    }
    return [];
  }

  getVoucherLevelSSAs(){
    if (lodash.has(this.props.orderDetails, 'metadata.serviceActions')){
      if (this.props.landingView){
        return lodash.intersection(VOUCHER_LEVEL_SSA_LANDING, this.props.orderDetails.metadata.serviceActions);
      }
      else
        return lodash.intersection(VOUCHER_LEVEL_SSAs, this.props.orderDetails.metadata.serviceActions);
    }
    return [];
  }

  render() {
    let orderLevelSSAList = this.getOrderLevelSSAs();
    let voucherLevelSSAList = this.getVoucherLevelSSAs();
    let orderLevelSSAFirst = false
    if (orderLevelSSAList.length > 0) {
      orderLevelSSAFirst = true
    }
    if(this.props.orderDetails.DEAL_TYPE == 'LOCAL' && Web2018Helper.isExperimentEnabled('isGrouponGuaranteeEnabled') && !voucherLevelSSAList.includes('trade_in') && !this.props.landingView){
      voucherLevelSSAList.push('inactive_trade_in');
    }
    if (this.props.landingView) {
     return (<div class = "ssa-landing">
        <DefaultSSA landingView={this.props.landingView} orderDetails = {this.props.orderDetails} />
        {(orderLevelSSAList.length > 0) &&
        <OrderLevelSSA landingView={this.props.landingView} firstSSA = {orderLevelSSAFirst} orderDetails = {this.props.orderDetails} SSAs = {orderLevelSSAList}
        />
        }
        {(voucherLevelSSAList.length > 0) &&
        <VoucherLevelSSA landingView={this.props.landingView} firstSSA = {!orderLevelSSAFirst} orderDetails = {this.props.orderDetails} SSAs = {voucherLevelSSAList}
        />
        }
      </div>
     )
    }
    else {
      return (
          <div>
            <DefaultSSA  orderDetails={this.props.orderDetails}/>
            {(orderLevelSSAList.length > 0) &&
            <OrderLevelSSA orderDetails={this.props.orderDetails}  SSAs={orderLevelSSAList}
            />
            }
            {(voucherLevelSSAList.length > 0) &&
            <VoucherLevelSSA orderDetails={this.props.orderDetails}  SSAs={voucherLevelSSAList}
            />
            }
          </div>

      );
    }
  }
}
module.exports = SSAButtons
